import { render, staticRenderFns } from "./templateSummary.vue?vue&type=template&id=459d2477&scoped=true"
import script from "./templateSummary.vue?vue&type=script&lang=js"
export * from "./templateSummary.vue?vue&type=script&lang=js"
import style0 from "./templateSummary.vue?vue&type=style&index=0&id=459d2477&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d2477",
  null
  
)

export default component.exports